import { graphql } from "gql";

const GET_ME_VULNERABILITY_DRAFTS = graphql(`
  query GetMeVulnerabilityDrafts(
    $after: String
    $canRetrieveHacker: Boolean! = true
    $findingTitle: String
    $first: Int
    $fromReportDate: DateTime
    $groupName: String
    $hacker: String
    $maxSeverityTemporalScore: Float
    $minSeverityTemporalScore: Float
    $organizationName: String
    $sourceType: VulnerabilitySourceType
    $state: VulnerabilityState
    $toReportDate: DateTime
  ) {
    me {
      __typename
      userEmail
      vulnerabilityDrafts(
        after: $after
        findingTitle: $findingTitle
        first: $first
        fromReportDate: $fromReportDate
        groupName: $groupName
        hacker: $hacker
        maxSeverityTemporalScore: $maxSeverityTemporalScore
        minSeverityTemporalScore: $minSeverityTemporalScore
        organizationName: $organizationName
        sourceType: $sourceType
        state: $state
        toReportDate: $toReportDate
      ) {
        total
        edges {
          node {
            ...vulnFields
            finding {
              id
              title
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`);

export { GET_ME_VULNERABILITY_DRAFTS };
